module.exports = __webpack_public_path__ + "img/img_3.1537c449.png";